import { useCallback, useState } from "react"

import toast from "react-hot-toast"
import { Button, Divider } from "semantic-ui-react"

import actions from "actions"
import api from "api"
import SettingActions from "components/lib/SettingActions"
import { useAppDispatch, useAppSelector } from "store"
import constants from "utils/constants"

import TermsCheckbox from "./TermsCheckbox"

const AgreeToTerms = () => {
  const dispatch = useAppDispatch()
  const user = useAppSelector((state) => state.user)
  const [hasAgreed, setHasAgreed] = useState(false)
  const [agreedCustomTerms, setAgreedCustomTerms] = useState(!user?.ownerOrganisation?.customTerms?.enabled)
  const [loading, setLoading] = useState(false)

  const clicked = useCallback(() => {
    if (hasAgreed) {
      setLoading(true)
      api.auth.agreeToTerms(
        constants.termsVersion,
        user?.ownerOrganisation?.customTerms?.version,
        (agreements) => {
          dispatch(actions.user.agreeTerms(agreements))
          setLoading(false)
        },
        (err) => {
          toast.error(err.message)
          setLoading(false)
        },
      )
    } else {
      toast.error("Please agree to the terms before continuing")
    }
  }, [hasAgreed, dispatch, user])

  return (
    <>
      <h3>We value your privacy</h3>
      <p>You are seeing this message because our Policies or Terms may have recently changed.</p>
      <TermsCheckbox
        organisation={user?.ownerOrganisation}
        agreed={hasAgreed}
        onAgree={(agreed) => setHasAgreed(agreed)}
        agreedCustomTerms={agreedCustomTerms}
        onAgreeCustomTerms={(agreed) => setAgreedCustomTerms(agreed)}
      />
      <Divider hidden />
      <SettingActions>
        <Button
          primary
          content="Continue"
          onClick={clicked}
          loading={loading}
          disabled={!hasAgreed || !agreedCustomTerms}
        />
      </SettingActions>
    </>
  )
}

export default AgreeToTerms
